import { Text } from '@/components';
import type { FC, PropsWithChildren } from 'react';
import type { z } from 'zod';
import { usePinpointDisplayName } from '../../hooks/pinpoint-display-name';
import type { PinpointModel } from '../../models/pinpoint';

type Pinpoint = z.infer<typeof PinpointModel>;
type Props = {
  pinpoint: Pinpoint;
  whiteSpace?: 'wrap';
};

export const PinpointDisplayText: FC<PropsWithChildren<Props>> = ({
  pinpoint,
  whiteSpace,
}) => {
  const { label, isLoading } = usePinpointDisplayName(pinpoint);
  return isLoading ? (
    <div />
  ) : (
    <Text
      style={{ whiteSpace }}
      text={label}
      weight="regular"
      variant="footnote"
    />
  );
};
